import React, { useEffect, useState } from "react";
import {
	ArrowLeftOutlined,
	CompressOutlined,
} from "@ant-design/icons";
import { Input } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { currencyFormat, isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";
import Currency from "../Currency/Currency";
import Auth from "../../lib/middleware/auth";
import { withdrawFunds } from "../../redux/actions/wallet";
import { useWalletBalance } from "../../redux/api/Transaction";
import { Loading } from "../Loading/Loading";

const Wrapper = styled.div`
	${tw`p-2 h-full bg-white w-full flex flex-col container`}
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}

	.ant-select-selection-search-input {
		padding-top: 15px !important;
	}
	.ant-select-selection-item,
	.ant-select-selection-placeholder {
		/* padding-top: 10px !important; */
		/* color: #dedef0 !important; */
		font-size: 0.875rem !important;
	}
	.ant-select-selection-placeholder {
		color: #db0a0a !important;
	}

	.ant-select-arrow {
		${tw`p-5 bg-appLightPink! rounded-full text-tiny! text-appPinkSaturated! flex! items-center! justify-center!`}
		padding: 10px;
		top: 45%;
		width: 8px;
		height: 8px;
	}
`;

const FundsWithdrawal = (props) => {
	const curr = Auth.getCurrency();
	const [balance, setBalance] = useState(0);

	const [fields, setFields] = useState({
		currencyCode: curr?.code,
		amount: "",
	});
	const currencyCode = curr?.code;
	const { data: withdrawable, isLoading: fetchingWitdrawable } =
		useWalletBalance({ currencyCode });
	console.log("bank data \n", withdrawable);

	useEffect(() => {
		if (isEmpty(withdrawable)) {
			return;
		}
		setBalance(withdrawable.withdrawable_amount);
	}, [withdrawable]);

	const { mutateAsync, isLoading } = useMutation(withdrawFunds);

	const handleWithdrawal = async () => {
		if (isEmpty(fields.currencyCode)) {
			return;
		}
		if (isEmpty(fields.amount)) {
			Toast.fire({
				icon: "error",
				title: `Please enter withdrawal amount`,
			});
			return;
		}
		// eslint-disable-next-line
		if (fields.amount == 0) {
			Toast.fire({
				icon: "error",
				title: `Please enter a valid amount`,
			});
			return;
		}
		if (fields.amount > withdrawable?.withdrawable_amount) {
			Toast.fire({
				icon: "error",
				title: `Insufficient funds available`,
			});
			return;
		}

		try {
			const response = await mutateAsync(fields);
			console.log("Account withdrawal res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				Toast.fire({
					icon: "error",
					title: `${response.data.errors.title}\n ${response.data.errors.message} `,
				});
				return;
			}
			Toast.fire({
				icon: "success",
				title: `${response.data.message} \n Preocessing withdrawal...`,
			});
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<Wrapper>
			<div
				tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={() => props.goBack()}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>
			<LandingTitle tw="text-center text-lg! mb-4">
				Enter withdrawal amount
			</LandingTitle>

			<div>
				<div tw="text-appGreenGauze text-base">
					Available Balance:
					{fetchingWitdrawable ? (
						<Loading
							tw="ml-2"
							icon={
								<CompressOutlined
									tw="ml-2"
									spin
									style={{ fontSize: 14 }}
								/>
							}
						/>
					) : (
						<span tw="text-lg font-bold ">
							{Number(currencyFormat(balance)).toFixed(2)}
						</span>
					)}
				</div>
				<div>
					<div tw="flex flex-row flex-nowrap gap-2 items-center">
						<Currency changeUserDefault={false} />
						<Input
							placeholder="₦ 00.00"
							type="number"
							css={inputStyle}
							maxLength="10"
							tw="mt-4 p-5! h-16 text-center "
							value={fields.amount}
							onChange={(e) => {
								setFields({
									...fields,
									amount: e.target.value.trim(),
								});
							}}
						/>
					</div>
				</div>
			</div>

			<div tw="mt-4 mb-8">
				<button
					css={btnStyle}
					tw="rounded-lg"
					onClick={handleWithdrawal}>
					{isLoading ? <Loading /> : "Continue"}
				</button>
			</div>
		</Wrapper>
	);
};

export default FundsWithdrawal;
